'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCustomWishlistNotification = exports.wishlistInstance = exports.addToWatchList = exports.removeFromWishList = exports.addToWishList = exports.getAllWishlistProducts = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _images = require('../utils/images');

var _functional = require('../utils/functional');

var _i18n = require('../services/i18n');

var _toast = require('../components/toast/toast');

var _tracking = require('../utils/tracking');

var _products = require('./products');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Swym Wishlist associated methods
 * Please refer to this page for documentation on the API
 * https://api-docs.swym.it/#custom-wishlist-page
 */

/**
 * Gets all products added to the Wishlist
 * Since it's a global method that depends on the swym script to be loaded, we need to check that it exists before executing
 *
 * @param {Function} cb - Callback function
 */
var getAllWishlistProducts = exports.getAllWishlistProducts = function getAllWishlistProducts(cb) {
  if (window._swat) {
    window._swat.fetchWrtEventTypeET(function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(res) {
        var products;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _promise2.default.all(res.map(function (product) {
                  return (0, _products.getProductByUrlCustomJSON)(product.du);
                }));

              case 2:
                products = _context.sent;

                cb(products);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), window._swat.EventTypes.addToWishList);
  } else {
    setTimeout(function () {
      getAllWishlistProducts(cb);
    }, 100);
  }
};

/**
 * Adds a product to the Wishlist and sends an event to GA4 tracking
 *
 * @param {Object} product
 * @param {number} product.productId - The product's ID
 * @param {string} product.productHandle - The product's handle
 * @param {number} product.variantId - The variant's ID
 * @param {string} product.featuredImage - The product's main image
 * @param {number} product.price - The product's price, in cents
 * @param {Function?} cb - Callback function
 */
var addToWishList = exports.addToWishList = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(product, cb) {
    var title, id, variantId, handle, featuredImage, price, imageUrl, fullProduct, variant, quantity, eventAddToWishlist;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            title = product.title, id = product.id, variantId = product.variantId, handle = product.handle, featuredImage = product.featuredImage, price = product.price;
            imageUrl = featuredImage.replace('https:', '').replace('http:', '');

            window._swat.addToWishList({
              dt: title,
              epi: variantId,
              du: location.origin + '/products/' + handle,
              empi: id,
              iu: imageUrl,
              pr: price / 100
            }, function (res) {
              return cb && cb(res);
            });

            _context2.next = 5;
            return (0, _products.getProductByHandle)(handle);

          case 5:
            fullProduct = _context2.sent;
            variant = fullProduct.variants[0];
            quantity = 1;
            eventAddToWishlist = new Event('add_to_wishlist');

            eventAddToWishlist.payload = (0, _tracking.setDataLayerItem)({ product: fullProduct, variant: variant, quantity: quantity });
            document.dispatchEvent(eventAddToWishlist);

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function addToWishList(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Removes a product from the Wishlist
 *
 * @param {Object} product
 * @param {number} product.id - The product's ID
 * @param {string} product.productHandle - The product's handle
 * @param {number} product.variantId - The variant's ID
 * @param {string} product.featuredImage - The product's main image
 * @param {number} product.price - The product's price, in cents
 * @param {Function?} cb - Callback function
 */
var removeFromWishList = exports.removeFromWishList = function removeFromWishList(product, cb) {
  var title = product.title,
      id = product.id,
      variantId = product.variantId,
      handle = product.handle,
      featuredImage = product.featuredImage,
      price = product.price;

  var imageUrl = featuredImage.replace('https:', '').replace('http:', '');

  window._swat.removeFromWishList({
    dt: title,
    epi: variantId,
    du: location.origin + '/products/' + handle,
    empi: id,
    iu: imageUrl,
    pr: price / 100
  }, function (res) {
    return cb && cb(res);
  });
};

/**
 * Adds a product to the watchlist
 *
 * @param {Object} product
 * @param {string} product.title - The product's title
 * @param {number} product.id - The product's ID
 * @param {string} product.handle - The product's handle
 * @param {number} product.variantId - The variant's ID
 * @param {string} product.featuredImage - The product's main image
 * @param {number} product.price - The product's price, in cents
 * @param {Object} clickEventObj - Event object of click listener event
 * @param {Function?} cb - Callback function
 */
var addToWatchList = exports.addToWatchList = function addToWatchList(product, clickEventObj, cb) {
  var title = product.title,
      id = product.id,
      variantId = product.variantId,
      handle = product.handle,
      featuredImage = product.featuredImage,
      price = product.price;

  var imageUrl = featuredImage.replace('https:', '').replace('http:', '');

  window._swat.addToWatchList(clickEventObj, {
    dt: title,
    epi: variantId,
    du: location.origin + '/products/' + handle,
    empi: id,
    et: 8, // event type 8 stands for registering a "notify me" event.
    iu: imageUrl,
    pr: price / 100
  }, function (res) {
    return cb && cb(res);
  });
};

var WishlistControl = function () {
  function WishlistControl() {
    (0, _classCallCheck3.default)(this, WishlistControl);

    this.state = null;
    this._loading = false;
    this.entries = [];

    this.updateWishlist();
  }

  (0, _createClass3.default)(WishlistControl, [{
    key: 'updateWishlist',
    value: function updateWishlist() {
      var _this = this;
      if (this._loading) return false;
      this._loading = true;

      getAllWishlistProducts(function (res) {
        _this.state = res;
        _this._loading = false;

        _this.notifyAll();
      });
    }
  }, {
    key: 'registerEntry',
    value: function registerEntry(variantId, cb) {
      this.entries.push({ variantId: variantId, cb: cb });
    }
  }, {
    key: 'notifyAll',
    value: function notifyAll() {
      var _this2 = this;

      this.entries.forEach(function (_ref3) {
        var variantId = _ref3.variantId,
            cb = _ref3.cb;

        var isAdded = !!_this2.state.find(function (product) {
          return product.variants[0].id === variantId;
        });
        cb(isAdded);
      });
    }
  }]);
  return WishlistControl;
}();

var wishlistInstance = exports.wishlistInstance = new WishlistControl();

/**
 * Adds a custom notification element when adding a product to the Wishlist
 */
var addCustomWishlistNotification = exports.addCustomWishlistNotification = function addCustomWishlistNotification() {
  var notificationMarkup = '\n    <a id="SwymNotificationToast" class="tst-Notification" href="' + window.theme.links.wishlist + '">\n      <img class="tst-Notification_Image" src="{{ iu }}" />\n      <p class="tst-Notification_Text">{{dt}} Product added to wishlist</p>\n      <span class="tst-Notification_Close js-Toast_CloseButton">\n        <span class="am-icon-close-thin"></span>\n      </span>\n    </a>';

  var swymCallbackFn = function swymCallbackFn(swat) {
    var showCustomNotification = function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
        var parentContainer, product, toastElement, toastText, toast, getVariantInfo;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                getVariantInfo = function getVariantInfo(variants) {
                  try {
                    var variantKeys = variants && variants !== '[]' ? (0, _keys2.default)(variants[0]) : [];
                    var variantinfo = void 0;

                    if (variantKeys.length) {
                      variantinfo = variantKeys[0];
                    }

                    return variantinfo === 'Default Title' ? '' : variantinfo;
                  } catch (err) {
                    return variants;
                  }
                };

                parentContainer = (0, _functional.getElement)('#SwymCustomNotificationContainer');
                product = event.detail.d;

                if (!parentContainer) {
                  _context3.next = 15;
                  break;
                }

                parentContainer.innerHTML = ''; // Reset old toasts
                product = window.SwymUtils.formatProductPrice(product);
                product.variantInfo = getVariantInfo(product.variants);
                parentContainer.innerHTML = window.SwymUtils.renderTemplateString(notificationMarkup, product);
                toastElement = (0, _functional.getElement)('#SwymNotificationToast');
                toastText = (0, _functional.getElement)('.tst-Notification_Text', { context: toastElement });

                toastText.innerHTML = (0, _i18n.t)('products.product.added_to_wishlist', { product_title: product.dt });
                toast = new _toast.Toast(toastElement, {
                  trackingCategory: 'Wishlist Notification',
                  trackingEventLabel: product.dt
                });
                _context3.next = 14;
                return (0, _images.deferLoadingImage)(product.iu);

              case 14:
                toast.setVisibility(true);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function showCustomNotification(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function (event) {
      // Show custom Notifications on event;
      showCustomNotification(event);
    });
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swymCallbackFn);
};